interface IIconTimeProps {
  className?: string;
}

export const IconTime = ({ className }: IIconTimeProps) => (
  <svg className={className} viewBox="0 0 12 12" fill="#337ab7" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 0.227997C2.813 0.227997 0.229004 2.812 0.229004 6C0.229004 9.188 2.813 11.771 6 11.771C9.187 11.771 11.771 9.187 11.771 6C11.771 2.813 9.187 0.227997 6 0.227997ZM6 10.271C3.645 10.271 1.729 8.355 1.729 6C1.729 3.645 3.645 1.728 6 1.728C8.355 1.728 10.271 3.644 10.271 6C10.271 8.356 8.355 10.271 6 10.271Z" />
    <path d="M7.75 6H6V3.25C6 3.112 5.888 3 5.75 3H5.25C5.112 3 5 3.112 5 3.25V6.75C5 6.888 5.112 7 5.25 7H7.75C7.888 7 8 6.888 8 6.75V6.25C8 6.112 7.888 6 7.75 6Z" />
  </svg>
);
